import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { registerUser, resetUserState } from "../redux/slices/authSlice";
import ClipLoader from "react-spinners/ClipLoader";

const SignUpRap = styled.div`
  height: 100vh;
  .all-sign-divs {
    display: flex;
    gap: 30px;
    padding: 15px;
    height: 100%;
  }
  .left-sign-div {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }
  .right-sign-div {
    width: 50%;
    border-radius: 15px;
  }

  .sign-1 p {
    color: #363d4f;
    font-weight: 400;
    font-size: 14px;
    max-width: 235px;
    text-align: center;
  }

  .sign-1 h2 {
    color: #060b13;
    font-weight: 600;
    font-size: 22px;
  }
  .sign-1 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }
  .sign-2,
  .sign-4 {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .plug-icon {
    background: #ed1c24;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .email-sign input {
    border: 0.8px solid #bac0d4b2;
    width: 400px;
    height: 48px;

    border-radius: 10px;
    padding-left: 35px;
  }
  .upper-sign-divs input {
    border: 0.8px solid #bac0d4b2;
    width: 190px;
    height: 48px;

    border-radius: 10px;
    padding-left: 15px;
  }
  .upper-sign-divs {
    display: flex;
    gap: 20px;
  }
  .email-sign {
    width: 400px;
    position: relative;
    display: flex;
    align-items: center;
  }

  .email-icon,
  .lock-icon {
    position: absolute;
    left: 10px;
  }

  .eye-icon {
    position: absolute;
    right: 10px;
    cursor: pointer;
  }
  .sign-3 label {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  /* Custom Checkbox Styling */
  .custom-checkbox {
    width: 16px;
    height: 16px;
    border-radius: 4px;

    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: none;
  }

  .custom-checkbox:checked::before {
    content: "✔";
    color: white;
    background: #ed1c24;
    width: 16px;
    height: 16px;
    border-radius: 4px;

    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: none;
  }
  .forget-link {
    color: #ed1c24;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
  }
  .sign-3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .login-btn {
    border-left: 2px;
    border-top: 2px;
    border-right: 5px;
    border-bottom: 5px;
    border-style: solid;
    background: #ed1c24;
    width: 400px;
    height: 55px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-color: #060b13;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
  }
  .login-btn:disabled {
    background: #fdb4b7;
    cursor: not-allowed;
    opacity: 0.6;
  }
  .line-div {
    width: 181px;
    height: 2px;
    background: #bac0d44d;
  }
  .all-line-div p {
    color: #475467;
    font-size: 12px;
    font-weight: 600;
  }
  .all-line-div {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .google-btn {
    color: #060b13;
    gap: 10px;
    background: #ffffff;
  }
  .have-account p {
    color: #475467;
    font-size: 14px;
    font-weight: 400;
  }
  .start-free-btn {
    color: #ed1c24;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
  }
  .have-account {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }
  .sign-5 p {
    color: #99a2af;
    font-size: 12px;
    font-weight: 400;
    max-width: 300px;
    text-align: center;
  }
  .sign-5 span {
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }

  @media (max-width: 992px) {
    .right-sign-div {
      display: none;
    }
    .left-sign-div {
      width: 100%;
    }
  }

  @media (max-width: 500px) {
    .email-sign input,
    .email-sign,
    .login-btn {
      width: 300px;
    }
    .login-btn {
      margin: auto;
    }
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background: white;
  border-radius: 16px;
  width: 450px;
  max-width: 90%;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  text-align: center;

  h3 {
    font-size: 22px;
    font-weight: 600;
    color: #060b13;
  }

  p {
    font-size: 16px;
    color: #475467;
    line-height: 1.5;
  }

  .login-now-btn {
    background: #ed1c24;
    color: white;
    border: none;
    padding: 12px 30px;
    border-radius: 100px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.3s;
    width: 100%;

    &:hover {
      background: #c4161c;
    }
  }

  .success-icon-div {
    background: #e6f7ed;
    color: #039855;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
`;

const TextOverlay = styled.div`
  position: absolute;
  bottom: 0px;
  left: 23%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 24px;
  font-weight: bold;
  z-index: 2;
  max-width: 328px;
  .text-divs p {
    background: #ed1c24;
    padding: 5px 12px;
    border-radius: 100px;
    font-size: 11px;
    font-weight: 400px;
    width: 94px;
    margin-bottom: 10px;
  }
  .text-divs h6 {
    max-width: 220px;
    font-size: 12px;
    font-weight: 500;
    color: #f2f2f2;
    line-height: 26px;
  }
`;

const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  background-size: cover;
  background-position: center;
  transition: background-image 1s ease-in-out;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #00000040;
    z-index: 1;
  }
`;

const Indicators = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => (props.active ? "#ffffff" : "#FFFFFF4D")};
  transition: background-color 0.3s;
`;

const images = [
  "/images/sign-1.png",
  "/images/sign-2.png",
  "/images/sign-3.png",
];

const SignUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error, user, token } = useSelector((state) => state.auth);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    fname: "",
    lname: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const isValid =
    formData.email.trim() !== "" &&
    formData.fname.trim() !== "" &&
    formData.lname.trim() !== "" &&
    formData.password.trim() !== "";

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isValid) {
      dispatch(registerUser(formData));
    }
  };

  useEffect(() => {
    if (
      user &&
      (token || user?.statusCode === 201 || user?.status === "CREATED")
    ) {
      localStorage.setItem(
        "pluglruserregisteredEmail",
        user?.data?.email || user?.user?.data?.email
      );
      localStorage.setItem("pluglrUserToken", token);
      localStorage.setItem(
        "pluglrUserDetails",
        JSON.stringify(user?.data || user?.user?.data)
      );
      setShowSuccessModal(true);
    }
  }, [user, token]);

  const handleLoginNow = () => {
    dispatch(resetUserState());
    navigate("/login", {
      state: {
        email: formData.email,
        password: formData.password,
      },
    });
  };

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleEmailMove = () => {
    navigate("/listener/dashboard");
  };
  return (
    <SignUpRap>
      <div className="all-sign-divs">
        <div className="left-sign-div">
          <div className="sign-1">
            <div className="plug-icon">
              <img src="/images/plu-icon.png" alt="" />
            </div>
            <h2>Create account</h2>
            <p>Welcome to Plugrl, let get you started in few minute</p>
          </div>
          <div className="sign-2">
            {error && (
              <p
                style={{
                  color: "red",
                  fontSize: "12px",
                  textAlign: "center",
                  maxWidth: "400px",
                }}
              >
                {typeof error === "string"
                  ? error
                  : error.message || "An error occurred during signup"}
              </p>
            )}

            <div className="upper-sign-divs">
              <input
                type="email"
                name="fname"
                placeholder="First Names"
                value={formData.fname}
                onChange={handleChange}
              />
              <input
                type="email"
                name="lname"
                placeholder="Last Name"
                value={formData.lname}
                onChange={handleChange}
              />
            </div>
            {/* Email Input */}
            <div className="email-sign">
              <Icon
                className="email-icon"
                icon="ic:outline-email"
                width="20"
                height="20"
                style={{
                  color: formData.email ? "#060B13" : "#99A2AF",
                }}
              />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            {/* Password Input */}
            <div className="email-sign">
              <Icon
                className="lock-icon"
                icon="solar:lock-keyhole-linear"
                width="20"
                height="20"
                style={{
                  color: formData.password ? "#060B13" : "#99A2AF",
                }}
              />
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
              />
              <Icon
                className="eye-icon"
                icon={showPassword ? "solar:eye-outline" : "mage:eye-off"}
                width="20"
                height="20"
                style={{ color: "#99A2AF" }}
                onClick={togglePasswordVisibility}
              />
            </div>
          </div>

          <div className="sign-4">
            <button
              onClick={handleSubmit}
              className="login-btn"
              disabled={!isValid}
            >
              {loading ? (
                <ClipLoader color="white" size={40} />
              ) : (
                "Create Account"
              )}
            </button>{" "}
            <div className="all-line-div">
              <div className="line-div"></div>
              <p>OR</p>
              <div className="line-div"></div>
            </div>
            <Link className="login-btn google-btn">
              <img src="/images/google.png" alt="" />
              <p>Continue with Google</p>
            </Link>
            <div className="have-account">
              <p>Have an account?</p>
              <Link to="/login" className="start-free-btn">
                Login
              </Link>
            </div>
          </div>
        </div>

        {/* Image Slider */}
        <div className="right-sign-div">
          <SliderContainer
            style={{ backgroundImage: `url(${images[currentIndex]})` }}
          >
            <TextOverlay>
              <div className="text-divs">
                <p>For creator</p>
                <h6>Craft your content and establish your own guidelines.</h6>
              </div>
            </TextOverlay>

            <Indicators>
              {images.map((_, index) => (
                <Dot key={index} active={currentIndex === index} />
              ))}
            </Indicators>
          </SliderContainer>
        </div>
      </div>

      {showSuccessModal && (
        <ModalOverlay>
          <ModalContainer>
            <div className="success-icon-div">
              <Icon icon="mdi:check-circle" width="40" height="40" />
            </div>
            <h3>Account Created!</h3>
            <p>
              You have successfully created your account. Login now to get
              started.
            </p>
            <button className="login-now-btn" onClick={handleLoginNow}>
              Login Now
            </button>
          </ModalContainer>
        </ModalOverlay>
      )}
    </SignUpRap>
  );
};

export default SignUp;
